import { position, drop } from '../directives';
import SelectedMark from './SelectedMark';

export default {
    name: "CustomLayoutMask",
    props: {
        layoutMan: {
            type: Object,
            required: true
        }
    },
    directives: { position, drop },
    methods: {

        OnMouseup(e) {

            const _elements = document.elementsFromPoint(e.pageX, e.pageY)

            let _layoutConfig = null;

            for (let _element of _elements) {

                if (_element?.__vue__?.$options.__LayoutComponent__) {
                    _layoutConfig = _element.__vue__.layoutConfig;
                    break;
                }

            }

            if (_layoutConfig) {
                this.layoutMan.SetSelectedList(_layoutConfig);
            }

        }
    },
    render(h) {
        
        const _selectedList = this.layoutMan.GetSelectedList();

        const _selectedMarkList = _selectedList.map(selected => (<SelectedMark props={{ mark: selected, layoutMan: this.layoutMan, color: "rgba(24, 144, 255, 0.4)"  }} />));
        
        const _controlMarkList = this.layoutMan.GetControlConfigList().filter(controlCfg => !_selectedList.includes(controlCfg))
            .map(controlConfig => (<SelectedMark  props={{ mark: controlConfig, layoutMan: this.layoutMan }}/>))
            
        return (
            <div class="layout-mask"
                v-position={this.layoutMan}
                onMouseup={this.OnMouseup}
            >
                <div v-drop={this.layoutMan}>
                    {_controlMarkList}
                    {_selectedMarkList}
                </div>
            </div>
        );
    }
};